import React, { useState } from "react";
import * as S from "./signup-poster.styles"; // Import the styles
import { EXPLAINER_VIDEO_LINK, EXPLAINER_VIDEO_THUMBNAIL } from "./constants"; // Import constants

export const ExplainerButton = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  // Convert YouTube URL to Embed URL
  const getYouTubeEmbedURL = (url) => {
    const videoId = url.split("v=")[1]?.split("&")[0]; // Extract video ID
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1`;
  };

  return (
    <S.ButtonContainer>
      {!isVideoPlaying ? (
        <S.Button
          id="gstModalOpenBtn"
          onClick={() => {
            setIsVideoPlaying(true); // Set video to play
          }}
        >
          Not sure? Watch our 60 second explainer video
          <br />
          <S.Thumbnail
            src={EXPLAINER_VIDEO_THUMBNAIL}
            alt="Explainer Video Thumbnail"
          />
        </S.Button>
      ) : (
        <S.VideoContainer>
          <S.Iframe
            src={getYouTubeEmbedURL(EXPLAINER_VIDEO_LINK)}
            title="Explainer Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </S.VideoContainer>
      )}
    </S.ButtonContainer>
  );
};
